export default __webpack_public_path__ + "static/media/2.440b20d3.jpg";